/* eslint-disable max-len */
import React, { useState } from 'react';
import { Button, Text, TextInput } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import S from './AuthenticatorAppConfirmation.css';
const {
  t
} = I18N.ns('login.twoFactor.AuthenticatorAppConfirmation');
export default function AuthenticatorAppConfirmation(props) {
  const {
    confirmationData,
    setConfirmationData,
    authenticationData,
    error
  } = props;
  const [showQR, setShowQR] = useState(true);
  const onChange = ({
    data,
    value
  }) => {
    setConfirmationData({
      ...confirmationData,
      [data]: value
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    variant: "twoStepTitle|title"
  }, t('title')), /*#__PURE__*/React.createElement(Text, null, t('subtitle')), /*#__PURE__*/React.createElement(Text, {
    variant: "subtitle"
  }, t('steps')), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Text, {
    className: S.inline
  }, t('install')), "\xA0", /*#__PURE__*/React.createElement("a", {
    className: S.link,
    target: "_blank",
    rel: "noreferrer",
    href: "https://support.google.com/accounts/answer/1066447?hl=en&co=GENIE.Platform%3DAndroid"
  }, t('googleAuthenticator')), "\xA0", /*#__PURE__*/React.createElement(Text, {
    className: S.inline
  }, t('instruction1'))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Text, null, t('instruction2'), /*#__PURE__*/React.createElement(Button, {
    className: S.link,
    variant: "linkNoPad",
    onClick: () => setShowQR(!showQR)
  }, showQR ? t('secretKey') : t('qrCode'))))), showQR ? /*#__PURE__*/React.createElement("img", {
    className: S.qrCode,
    src: authenticationData?.qrCode,
    alt: t('qrCodeAlt')
  }) : /*#__PURE__*/React.createElement(Text, {
    variant: "authenticatorAppKey|subtitle",
    className: S.key
  }, authenticationData?.key), /*#__PURE__*/React.createElement("ol", {
    start: 3
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Text, null, authenticationData.message))), error && /*#__PURE__*/React.createElement(Text, {
    variant: "twoFactorWarning"
  }, error), /*#__PURE__*/React.createElement(TextInput, {
    hint: t('hint'),
    autoComplete: "one-time-code",
    value: confirmationData?.code,
    eventData: "code",
    onChange: onChange,
    changeOnReturn: false
  }));
}